import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const SortAscIcon: FC<SVGProps<SVGSVGElement>> = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="100%" height="100%" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.16666 5.01552L4.49999 1.66675L7.83332 5.01552" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};